module.exports = __webpack_public_path__ + "static/media/close.00889830.svg";